import React from 'react';
import { StarIcon, CheckCircle2Icon } from 'lucide-react';
const testimonials = [{
  text: 'Soffro di Hashimoto da 10 anni e pensavo che il gonfiore fosse il mio destino. Dopo solo 10 giorni con le ricette di Tiroide Felice, ho perso quel fastidioso senso di pesantezza. Le ricette sono buonissime e velocissime.',
  name: 'Elena M.',
  role: 'Docente, 52 anni',
  city: 'Milano'
}, {
  text: 'Insegno storia e arrivavo a metà mattina senza forze. Questo kit mi ha cambiato la vita. Le colazioni proteiche consigliate mi danno una carica che non provavo da anni. Indispensabile per chi lavora e ha poco tempo.',
  name: 'Chiara D.',
  role: 'Docente, 48 anni',
  city: 'Torino'
}, {
  text: 'Ero scettica perché avevo provato di tutto. Ma il Protocollo 360° mi ha fatto capire dove sbagliavo con gli integratori e lo stress. Ho perso 4 kg nel primo mese senza mai soffrire la fame. Grazie!',
  name: 'Alessandra P.',
  role: 'Impiegata, 45 anni',
  city: 'Roma'
}, {
  text: 'Cucinare diversamente per me e per mio marito era un incubo. Ora mangiamo entrambi le stesse cose e anche lui si sente meglio! La lista della spesa per la Coop è utilissima.',
  name: 'Silvia B.',
  role: 'Infermiera, 50 anni',
  city: 'Bari'
}, {
  text: 'La cosa migliore non è solo il peso, ma la lucidità. Non ho più quella stanchezza cronica che mi distruggeva le serate. Consiglio assolutamente il pacchetto completo.',
  name: 'Giovanna L.',
  role: 'Farmacista, 55 anni',
  city: 'Napoli'
}];
export function Testimonials() {
  return <section className="py-8 px-4 bg-white" data-id="element-196">
      <div className="max-w-3xl mx-auto" data-id="element-197">
        <div className="text-center mb-8" data-id="element-198">
          <h2 className="text-xl sm:text-2xl font-heading font-bold text-brand-primary mb-2" data-id="element-199">
            ⭐ COSA DICONO LE DONNE CHE LO USANO OGNI GIORNO
          </h2>
          <p className="text-sm text-brand-text" data-id="element-200">
            Oltre +800 donne in Italia hanno già trasformato la loro vita.
          </p>
        </div>

        <div className="space-y-4" data-id="element-201">
          {testimonials.map((t, i) => <div key={i} className="bg-brand-soft border border-brand-border rounded-lg p-5" data-id="element-202">
              <div className="flex items-center gap-2 mb-3" data-id="element-203">
                <CheckCircle2Icon className="w-4 h-4 text-green-600" data-id="element-204" />
                <span className="text-xs font-bold text-green-600 uppercase" data-id="element-205">
                  Verificato
                </span>
              </div>

              <div className="flex items-center gap-1 mb-3" data-id="element-206">
                {[...Array(5)].map((_, idx) => <StarIcon key={idx} className="w-4 h-4 text-yellow-500 fill-current" data-id="element-207" />)}
              </div>

              <p className="text-sm text-brand-text italic mb-4 leading-relaxed" data-id="element-208">
                "{t.text}"
              </p>

              <div className="border-t border-brand-border pt-3" data-id="element-209">
                <div className="font-bold text-brand-primary text-sm" data-id="element-210">
                  — {t.name}
                </div>
                <div className="text-xs text-brand-muted" data-id="element-211">
                  {t.role} • {t.city}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}